import {requestHelpers} from '../../helpers';
const actions = {
    SET_ACCOUNT: 'SET_ACCOUNT',
    SET_TRANSACTION_HISTORY: 'SET_TRANSACTION_HISTORY',
    SET_TRANSACTION_RECEIPT: 'SET_TRANSACTION_RECEIPT',
    SET_PREFERENCES: 'SET_PREFERENCES',
    UPDATE_CONTACT_DETAILS: 'UPDATE_CONTACT_DETAILS_FORM',
    UPDATE_CONTACT_DETAILS_REQUEST: 'UPDATE_CONTACT_DETAILS_REQUEST',
    UPDATE_PREFERENCES: 'UPDATE_PREFERENCES',
    UPDATE_PASSWORD: 'UPDATE_PASSWORD',
    GET_PREFERRED_NETWORK: "GET_PREFERRED_NETWORK",
    SET_PREFERRED_NETWORK: "SET_PREFERRED_NETWORK",
};

function setAccount(person_id) {
    return (dispatch) => {

        requestHelpers
            .authenticatedGetRequest(`/people/${person_id}`)
            .then((response) => {
                return dispatch({
                    type: actions.SET_ACCOUNT,
                    account: response.data,
                });
            })
            .catch( console.error );
    }
}

function setTransactionHistory(person_id) {
    return (dispatch) => {
        requestHelpers
            .authenticatedGetRequest(`/transactions/people/${person_id}`)
            .then((response) => {
                return dispatch({
                    type: actions.SET_TRANSACTION_HISTORY,
                    transactionHistory: response.data,
                });
            })
            .catch( console.error );
    }

}

function setTransactionReceipt(transaction_id) {
    return (dispatch) => {
        requestHelpers
            .authenticatedGetRequest(`/transactions/${transaction_id}/receipt`)
            .then((response) => {
                return dispatch({
                    type: actions.SET_TRANSACTION_RECEIPT,
                    transactionReceipt: response.data,
                });
            })
            .catch( console.error );
    }
}

function setPreferences(person_id) {
    return (dispatch) => {

        requestHelpers
            .authenticatedGetRequest(`/people/${person_id}/preferences/communications`)
            .then((response) => {
                return dispatch({
                    type: actions.SET_PREFERENCES,
                    preferences: response.data,
                });
            })
            .catch( console.error );
    }
}

function updateContactDetails(personId, contactDetails) {

    const _contactDetails = {};

    _contactDetails.first_name = contactDetails.first_name;
    _contactDetails.last_name = contactDetails.last_name;
    _contactDetails.email_address = contactDetails.email_address;
    _contactDetails.phone_number = contactDetails.phone_number;
    if ( contactDetails.gender_id ) {
        _contactDetails.gender_id = contactDetails.gender_id.value;
    }

    return (dispatch) => {
        dispatch({
            type: actions.UPDATE_CONTACT_DETAILS_REQUEST
        })
        requestHelpers
            .authenticatedPostRequest(`/people/update/${personId}`, _contactDetails, "PUT")
            .then((response) => {
                return dispatch({
                    type: actions.UPDATE_CONTACT_DETAILS,
                    _contactDetails,
                })
            })
            .catch( console.error );
    }
}

function updatePreferences ( personId, preferences ) {
    const formData = new FormData();
    formData.append( "preferences", JSON.stringify( preferences ) );
    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest( `/people/${personId}/preferences/communications`, formData, "PUT", "FORM" )
            .then( ( response ) => {
                return dispatch ({
                    type: actions.UPDATE_PREFERENCES,
                    preferences: preferences,
                    response,
                })
            })
            .catch( console.error );
    }
}

function updatePassword (password) {

    const _password ={};

    _password.password = password.password;
    _password.password_confirmation = password.password_confirmation;

    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest(`/authentication/password/update`, _password )
            .then((response) => {
                return dispatch({
                    type: actions.UPDATE_PASSWORD,
                    success: response.success,
                })
            })
            .catch( console.error );
    }
}

function getPreferredNetwork( personId ) {
    return dispatch => {
        requestHelpers.authenticatedGetRequest( `/people/${ personId }/networks/primary` )
            .then( response => {
                return dispatch( {
                    type: actions.GET_PREFERRED_NETWORK,
                    preferred_network: response,
                } );
            } )
            .catch( console.error );
    };
}

function setPreferredNetwork( personId, network ) {
    return () => {
        requestHelpers.authenticatedPostRequest( `/people/${ personId }/networks/primary`, network )
            .catch( console.error );
    };
}

module.exports = {
    actions,
    setAccount,
    setTransactionHistory,
    setPreferences,
    updateContactDetails,
    updatePreferences,
    updatePassword,
    setTransactionReceipt,
    getPreferredNetwork,
    setPreferredNetwork,
};



// WEBPACK FOOTER //
// src/client/actions/account/account.js